<script setup>
const props = defineProps({
    length: {
        type: Number,
        required: true,
    },
});
const idx = defineModel();
</script>

<template>
    <div class="c-slide-pager">
        <button class="c-slide-pager__item" v-for="(item, index) in length" :key="index" :class="{ '-active': index === idx }" @click="idx = index"></button>
    </div>
</template>
